import { GetData } from "./Functions/SettingData";
import CODE from "../Static/Constants/StatusCodes";

export const getRbacFleets = async () => {
  const config = {
    method: "get",
    url: `/api/rbac/me/fleets`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const getRbacLocations = async (fleetIds = []) => {
  const config = {
    method: "get",
    url: `/api/rbac/me/locations`,
    headers: {
      "Content-Type": "application/json",
      ...(fleetIds.length > 0 ? { fleetids: btoa(JSON.stringify(fleetIds)) } : {}),
    },
  };
  return GetData(config);
};

/**
 * Fetch user's RBAC permissions from backend
 * @returns {Promise} Response with user permissions
 */
export const getUserPermissions = async () => {
  const config = {
    method: "get",
    url: `/api/rbac/me/permissions`,
    headers: { "Content-Type": "application/json" }
  };

  try {
    const data = await GetData(config);
    return data;
  } catch (error) {
    console.error("Failed to fetch RBAC permissions:", error);
    throw error;
  }
};

/**
 * Fetch user's assigned roles
 * @returns {Promise} Response with user roles
 */
export const getUserRoles = async () => {
  const config = {
    method: "get",
    url: `/api/rbac/me/roles`,
    headers: { "Content-Type": "application/json" }
  };

  try {
    const data = await GetData(config);
    return data;
  } catch (error) {
    console.error("Failed to fetch user roles:", error);
    throw error;
  }
};
